import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to check if AI grading is configured for the current tenant
 * @returns Query hook with boolean indicating if AI grading is available
 */
export const useIsAIGradingConfigured = () => {
    const axios = useAxios();

    const checkAIGradingConfigured = async (): Promise<boolean> => {
        try {
            const response = await axios.get<boolean>(
                `/api/ExamInstanceQuestion/ai-grading-configured`
            );
            return response.data;
        } catch (error) {
            // If the check fails, assume not configured
            return false;
        }
    };

    return useQuery({
        queryKey: ["aiGradingConfigured"],
        queryFn: checkAIGradingConfigured,
        staleTime: 10 * 60 * 1000, // Cache for 10 minutes
        retry: false
    });
};
